import { PostDonationForm as PagePostDonationForm } from '@web/components/page-components/PostDonationForm'
import { AddressInput, PostDonationForm as PostDonationFormProps } from '@web/graphql-components'
import environment from 'apps/fe-donation/libs/environment'
import { usePaymentStore } from 'apps/fe-donation/libs/hooks/usePaymentStore'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { useSubmitPostDonationFormValuesMutation } from 'apps/fe-donation/libs/queries'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { toPostDonationFormSubmission } from './postDonationFormValues'
import SubComponent from './SubComponent'

const presentId = (value: string | null | undefined) => {
  const trimmed = value?.trim()
  return trimmed ? trimmed : undefined
}

const PostDonationForm = (props: PostDonationFormProps) => {
  const searchParams = useSearchParams()
  const paymentTransactionId = usePaymentStore((state) => state.paymentTransactionId)
  const paymentSubscriptionId = usePaymentStore((state) => state.paymentSubscriptionId)
  const transactionId = presentId(paymentTransactionId) ?? presentId(searchParams.get('ptid'))
  const subscriptionId = presentId(paymentSubscriptionId) ?? presentId(searchParams.get('psid'))
  const hasSuccessfulPayment = Boolean(transactionId || subscriptionId)
  const storageKey = hasSuccessfulPayment ? `post-donation-form:${props.id}:${transactionId ?? subscriptionId}` : null
  const [submitted, setSubmitted] = useState(false)
  const { mutateAsync: submitPostDonationFormValues } = useSubmitPostDonationFormValuesMutation()

  useEffect(() => {
    if (!storageKey) {
      return
    }

    setSubmitted(window.sessionStorage.getItem(storageKey) === 'true')
  }, [storageKey])

  if (!hasSuccessfulPayment) {
    return null
  }

  const onSubmit = async (values: { [key: string]: string }, address?: AddressInput | null) => {
    const submission = toPostDonationFormSubmission(props.extraFields ?? [], values, address)

    await submitPostDonationFormValues({
      charityId: usePageStore.getState().charityId,
      transactionId,
      paymentSubscriptionId: subscriptionId,
      ...(submission.mobile ? { mobile: submission.mobile } : {}),
      ...(submission.address ? { address: submission.address } : {}),
      customFields: submission.customFields,
    })

    if (storageKey) {
      window.sessionStorage.setItem(storageKey, 'true')
    }
    setSubmitted(true)
  }

  return (
    <PagePostDonationForm
      {...props}
      interactive
      submitted={submitted}
      googleMapsApiKey={environment.googleMapsApiKey}
      onSubmit={onSubmit}
      SubComponent={SubComponent}
    />
  )
}

export default PostDonationForm
